import { render } from "./PaymentCompletePage.vue?vue&type=template&id=7040f154&scoped=true"
import script from "./PaymentCompletePage.vue?vue&type=script&lang=js"
export * from "./PaymentCompletePage.vue?vue&type=script&lang=js"

import "./PaymentCompletePage.vue?vue&type=style&index=0&id=7040f154&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7040f154"]])

export default __exports__